import { render } from "./ConsultancyPage.vue?vue&type=template&id=646062a9&scoped=true"
import script from "./ConsultancyPage.vue?vue&type=script&lang=js"
export * from "./ConsultancyPage.vue?vue&type=script&lang=js"

import "./ConsultancyPage.vue?vue&type=style&index=0&id=646062a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646062a9"]])

export default __exports__